module.exports = ":root{--lui-productlogo-text-display:block;--lui-productlogo-text-max-width:auto}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-logo/theme/lui-productlogo.global.scss
// module id = 240
// module chunks = 0 1 10